export const PYXIS_SESSION_ID = 'MTL-PYXIS-SESSION-ID';
